import { Service } from '../types';

export const services: Service[] = [
  {
    id: 1,
    title: 'AI Strategy Development',
    description: 'We help you unlock core value for your business with AI, defining your platform approach: build, buy, or partner.',
    icon: 'compass',
  },
  {
    id: 2,
    title: 'Innovation Leadership',
    description: 'Leverage our decades of experience driving AI innovation at global tech companies to accelerate your AI initiatives.',
    icon: 'lightbulb',
  },
  {
    id: 3,
    title: 'Governance & Risk',
    description: 'Align governance, data, and risk frameworks to support scale while maintaining trust and compliance.',
    icon: 'shield',
  },
  {
    id: 4,
    title: 'Workforce Development',
    description: 'Upskill your existing workforce to effectively leverage AI technologies and drive innovation from within.',
    icon: 'users',
  },
  {
    id: 5,
    title: 'Responsible AI',
    description: 'Build trust and minimize risk with comprehensive responsible AI practices and ethical frameworks.',
    icon: 'scale',
  },
  {
    id: 6,
    title: 'Generative AI Solutions',
    description: 'Transform your business with cutting-edge generative AI applications and use cases.',
    icon: 'sparkles',
  }
];